// material-ui
import { useTheme } from '@mui/material/styles';
import React, { useState, useEffect } from 'react';
import {
    Grid,
    Typography,
    Alert,
    Radio,
    Box,
    Card, CardHeader, CardContent,
} from '@mui/material';
// project imports
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';



// ==============================|| PROFILE 1 - CHANGE PASSWORD ||============================== //

const styles = {
    ul: {
        '& .MuiPaginationItem-root': {
            '&.Mui-selected': {
                background: '#FF9800',
                color: 'white',
                borderRadius: '50%',
            },
        },
    },
    backdrop: (theme) => ({
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    })
};

const Gdpr = ({ EmployeeNr, OrganizationTypeId }) => {
    const theme = useTheme();

    if (EmployeeNr === 0) {
        return (
            <Grid container spacing={2}>
                <Grid
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 12
                    }}>
                    <Alert variant="outlined" severity="error" sx={{ borderColor: theme.palette.warning.dark }}>
                        <Typography variant='h5' style={{ color: 'red' }}>Önce Kayıt İşlemini Tamamlamanız Gerekli!....
                        </Typography>
                    </Alert>      </Grid>
            </Grid>
        );
    }

    useEffect(() => {
        getEmployeeGdpr();
    }, []);

    const SessionUser = getUser();

    const [permissions, setPermissions] = useState({
        permission: '',
        permission2: '',
        permission3: '',
        permission5: '',
    });

    const handlePermissionChange = (value) => {
        const updatedPermissions = { ...permissions, permission: value };
        setPermissions(updatedPermissions);
        savePermissions(updatedPermissions);
    };

    const handlePermissionChange2 = (value) => {
        const updatedPermissions = { ...permissions, permission2: value };
        setPermissions(updatedPermissions);
        savePermissions(updatedPermissions);
    };

    const handlePermissionChange3 = (value) => {
        const updatedPermissions = { ...permissions, permission3: value };
        setPermissions(updatedPermissions);
        savePermissions(updatedPermissions);
    };

    const handlePermissionChange5 = (value) => {
        const updatedPermissions = { ...permissions, permission5: value };
        setPermissions(updatedPermissions);
        savePermissions(updatedPermissions);
    };


    function savePermissions(permissions) {
        const updatedPermissions = { ...permissions, EmployeeNr };
        const updatedPermissionss = { ...updatedPermissions, RoleId: SessionUser.ManagementRoleId };
        axios.post('/SetApolloEmployeeGdpr', updatedPermissionss)
            .then(response => {
                console.log(response)
                if (response.status === 200) {
                    getEmployeeGdpr();
                    console.log('İzinler başarıyla kaydedildi:', response.data);
                } else {
                    getEmployeeGdpr();
                    console.log('İzinler kaydedilemedi. Sunucudan geçersiz bir yanıt alındı.');
                }
            })
            .catch(error => {
                console.error('İzinleri kaydederken bir hata oluştu:', error.message);
            });
    }

    const getEmployeeGdpr = () => {
        axios.get(`GetEmployeeGdpr/${EmployeeNr}`)
            .then((response) => {
                if (response.data && response.data.length > 0) {
                    const employeeGdprData = response.data[0];
                    setPermissions(employeeGdprData);
                } else {
                    console.log('İzinler bulunamadı.');
                }
            })
            .catch((error) => {
                console.error('İzinleri alma işlemi sırasında bir hata oluştu:', error.message);
            });
    };


    return (
        <>
            {[
                {
                    title: 'Doğum Günü',
                    description: "Doğum günümde Arçelik İnsan Kaynakları'nın benimle iletişim kurmasına izin veriyorum.",
                    permission: permissions.permission,
                    handlePermissionChange: handlePermissionChange
                },
                {
                    title: 'İş Yıl Dönümü',
                    description: "İş yıl dönümünde Arçelik İnsan Kaynakları'nın benimle iletişim kurmasına izin veriyorum.",
                    permission: permissions.permission2,
                    handlePermissionChange: handlePermissionChange2
                },
                {
                    title: 'Bayram Tebriği & Özel Günler',
                    description: "Bayramlarda Arçelik İnsan Kaynakları'nın benimle iletişime geçmesine izin veriyorum.",
                    permission: permissions.permission3,
                    handlePermissionChange: handlePermissionChange3
                },
                {
                    title: 'Duyurular',
                    description: "Rapid360 duyurularının tarafıma ulaşmasına izin veriyorum.",
                    permission: permissions.permission5,
                    handlePermissionChange: handlePermissionChange5,
                    visibleFor: 2 // Duyurular yalnızca OrganizationTypeId = 2 için görünür
                },
            ].filter(item => item.visibleFor === undefined || item.visibleFor === OrganizationTypeId) // Filtreleme işlemi
                .map((item, index) => (
                    <Grid key={index} size={12}>
                        <Card sx={{ backgroundColor: '#f5f5f5' }}>
                            <CardHeader
                                title={item.title}
                                sx={{ backgroundColor: '#bdbdbd' }}
                            />
                            <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography variant="body1">{item.description}</Typography>
                                <div style={{ display: 'flex' }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <Typography variant="caption" sx={{ color: 'error.main', fontWeight: 600 }}>RET</Typography>
                                        <Radio
                                            checked={item.permission === 0}
                                            onChange={() => item.handlePermissionChange(0)}
                                            value={0}
                                            color="error"
                                            name={`permission_${index}`}
                                            disabled={![6, 7].includes(SessionUser?.ManagementRoleId)}
                                        />
                                    </Box>
                                    <Box sx={{ width: 16 }} /> {/* Boşluk */}
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <Typography variant="caption" sx={{ color: 'success.main', fontWeight: 600 }}>ONAY</Typography>
                                        <Radio
                                            checked={item.permission === 1}
                                            onChange={() => item.handlePermissionChange(1)}
                                            value={1}
                                            color="success"
                                            name={`permission_${index}`}
                                            disabled={![6, 7].includes(SessionUser?.ManagementRoleId)}
                                        />
                                    </Box>
                                </div>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            {/* {[1, 4, 5].includes(SessionUser?.ManagementRoleId) && (
                    <Card sx={{ backgroundColor: '#f5f5f5' }}>
                        <CardHeader
                            title={
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span>Özlük Dosyası</span>
                                    <span style={{ marginLeft: 'auto' }}>RET  ONAY</span>
                                </div>
                            }
                            sx={{ backgroundColor: '#bdbdbd' }}
                        />
                        <CardContent sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant="body1">Bu kişinin özlük dosyasını hukuki yükümlülüklere uygun topladım.</Typography>
                            <div style={{ display: 'flex' }}>
                                <Radio
                                    checked={permissions.permission4 === 0}
                                    onChange={() => handlePermissionChange4(0)}
                                    value={0}
                                    color="error"
                                    name={`permission_4`}
                                />
                                <Box sx={{ width: 16 }} /> {/* Boşluk */}
            {/* <Radio
                                    checked={permissions.permission4 === 1}
                                    onChange={() => handlePermissionChange4(1)}
                                    value={1}
                                    color="success"
                                    name={`permission_4`}
                                />
                            </div>
                        </CardContent>
                    </Card>
                )} */}
        </>
    );
};
export default Gdpr;
